import React, { useState } from "react";
import TextInput from "./TextInput";
import UrlInput from "./UrlInput";
import { TableData } from "../types";

interface LeftSectionProps {
  text: string;
  onTextChange: (text: string) => void;
  onUrlChange: (url: string) => void;
  onKeywordChange: (keyword: string) => void;
  onPrimaryKeywordChange: (keyword: string) => void;
  onSecondaryKeyword1Change: (keyword: string) => void;
  onSecondaryKeyword2Change: (keyword: string) => void;
  onSubmit: (calculatePlacement?: boolean) => void;
  onTableDataChange: (data: TableData[]) => void;
  onActiveTabChange: (tab: "text" | "url") => void; // Ensure this prop is passed
  primaryKeyword: string;
  secondaryKeyword1: string;
  secondaryKeyword2: string;
  url: string;
}

const LeftSection: React.FC<LeftSectionProps> = ({
  text,
  onTextChange,
  onUrlChange,
  onKeywordChange,
  onPrimaryKeywordChange,
  onSecondaryKeyword1Change,
  onSecondaryKeyword2Change,
  onSubmit,
  onTableDataChange,
  onActiveTabChange,
  primaryKeyword,
  secondaryKeyword1,
  secondaryKeyword2,
  url,
}) => {
  const [activeTab, setActiveTab] = useState<"text" | "url">("text");
  const isMobile = window.innerWidth <= 768;

  const handleTabChange = (tab: "text" | "url") => {
    setActiveTab(tab);
    onActiveTabChange(tab); // Notify parent of tab change
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flex: isMobile ? "1 0 auto" : "0 0 500px",
        width: isMobile ? "100%" : "500px",
        height: isMobile ? "500px" : "600px",
        border: "1px solid #A8DE66",
        borderRadius: "8px",
        backgroundColor: "#fff",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "1rem",
          minHeight: "0",
          flex: "1 0 auto",
        }}
      >
        <div style={{ display: "flex", marginBottom: "1rem" }}>
          <button
            onClick={() => handleTabChange("text")}
            style={{
              flex: 1,
              padding: "0.75rem",
              backgroundColor: activeTab === "text" ? "#8CC540" : "#f8f9fa",
              color: activeTab === "text" ? "white" : "#333",
              border: `1px solid #A8DE66`,
              borderBottom: activeTab === "text" ? "none" : "1px solid #A8DE66",
              borderRadius: "4px 0 0 4px",
              cursor: "pointer",
              fontSize: "1rem",
              transition: "background-color 0.2s",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor =
                activeTab === "text" ? "#6B9A30" : "#e9ecef")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor =
                activeTab === "text" ? "#8CC540" : "#f8f9fa")
            }
          >
            Text Input
          </button>
          <button
            onClick={() => handleTabChange("url")}
            style={{
              flex: 1,
              padding: "0.75rem",
              backgroundColor: activeTab === "url" ? "#8CC540" : "#f8f9fa",
              color: activeTab === "url" ? "white" : "#333",
              border: `1px solid #A8DE66`,
              borderBottom: activeTab === "url" ? "none" : "1px solid #A8DE66",
              borderRadius: "0 4px 4px 0",
              cursor: "pointer",
              fontSize: "1rem",
              transition: "background-color 0.2s",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor =
                activeTab === "url" ? "#6B9A30" : "#e9ecef")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor =
                activeTab === "url" ? "#8CC540" : "#f8f9fa")
            }
          >
            URL Input
          </button>
        </div>

        <div
          style={{
            flex: "1 1 auto",
            overflowY: "auto",
            maxHeight: isMobile ? "calc(500px - 6rem)" : "calc(600px - 6rem)",
            paddingRight: "0.5rem",
          }}
        >
          {activeTab === "text" && (
            <TextInput
              text={text}
              onTextChange={onTextChange}
              onPrimaryKeywordChange={onPrimaryKeywordChange}
              onSecondaryKeyword1Change={onSecondaryKeyword1Change}
              onSecondaryKeyword2Change={onSecondaryKeyword2Change}
              onSubmit={onSubmit}
              primaryKeyword={primaryKeyword}
              secondaryKeyword1={secondaryKeyword1}
              secondaryKeyword2={secondaryKeyword2}
            />
          )}
          {activeTab === "url" && (
            <UrlInput
              onUrlChange={onUrlChange}
              primaryKeyword={primaryKeyword}
              secondaryKeyword1={secondaryKeyword1}
              secondaryKeyword2={secondaryKeyword2}
              onPrimaryKeywordChange={onPrimaryKeywordChange}
              onSecondaryKeyword1Change={onSecondaryKeyword1Change}
              onSecondaryKeyword2Change={onSecondaryKeyword2Change}
              onTableDataChange={onTableDataChange}
              onSubmit={onSubmit}
              url={url}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default LeftSection;